import React, { useEffect, useRef } from 'react';
import { AskStanleyFloatingButton } from './AskStanleyFloatingButton';
import { AskStanleyChatInterface } from './AskStanleyChatInterface';
import { useAskStanley } from '../hooks/useAskStanley';
import { useLocation, useSearchParams } from 'react-router-dom';

interface AskStanleyProps {
    hideFab?: boolean;
}

export const AskStanley: React.FC<AskStanleyProps> = ({ hideFab = false }) => {
    const { isOpen, openChat, closeChat, sendMessage } = useAskStanley();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const hasProcessedPromptRef = useRef(false);

    // Check for URL prompt parameter and auto-open/send
    useEffect(() => {
        const prompt = searchParams.get('prompt');
        if (prompt && !hasProcessedPromptRef.current) {
            hasProcessedPromptRef.current = true;
            openChat('url_prompt');
            // Small delay to ensure chat is open before sending
            setTimeout(() => {
                sendMessage(prompt, []);
                // Remove prompt from URL after processing
                searchParams.delete('prompt');
                setSearchParams(searchParams, { replace: true });
            }, 100);
        }
    }, [searchParams, openChat, sendMessage, setSearchParams]);

    useEffect(() => {
        // Close the chat whenever the location changes (but not when just search params change)
        closeChat();
        // Reset prompt processing flag on location change
        hasProcessedPromptRef.current = false;
    }, [location.pathname]);

    return (
        <>
            {!hideFab && <AskStanleyFloatingButton onClick={() => openChat('floating_button')} isOpen={isOpen} />}
            <AskStanleyChatInterface isOpen={isOpen} onClose={closeChat} />
        </>
    );
};
